import { gql } from 'apollo-boost'

const SCRAPING_TEST_CASES = gql`
  query scrapingTestCases(
    $filters: ScrapingTestCaseFiltersInput!
    $page: Int
    $pageSize: Int
  ) {
    scrapingTestCases(filters: $filters, page: $page, pageSize: $pageSize) {
      scrapingTestCases {
        id
        menuId
        menuUrl
        tags {
          id
          name
          type
        }
        createdAt
        updatedAt
      }
      total
    }
  }
`

export default SCRAPING_TEST_CASES
